<template>
<div>
<kn-jumbotron></kn-jumbotron>
<b-container fluid>   
<b-row class="h-100" id="pnfRow" >
    <kn-sideMenu></kn-sideMenu>
    <h2 id="pnf"><span class="fa fa-exclamation-triangle fa-2x"></span> Η σελίδα που αναζητήσατε δεν υπάρχει,
    επιστρέψτε στην<router-link to="/"> αρχική σελίδα</router-link>.</h2>
</b-row>
</b-container>
<kn-footer></kn-footer>
</div>
</template>

<script>
import jumbotron from './jumbotron.vue';
import sideMenu from './sideMenu.vue';
import footer from './footer.vue'
export default {
  components: {
    "kn-jumbotron": jumbotron,
    "kn-sideMenu": sideMenu,
    "kn-footer": footer
  },
}
</script>

<style lang="scss">
#pnf{
    height: 500px;
    padding-top: 224px;
    padding-left: 40px;
}
#pnfRow{
    box-shadow: 10px 10px 5px grey;
}
</style>



// WEBPACK FOOTER //
// src/components/pageNotFound.vue